import { Check } from "lucide-react"

import { cn } from "@/lib/utils"
import type { SearchScope } from "@/types/api"

const OPTIONS: { scope: SearchScope; label: string; title: string }[] = [
  { scope: "sharepoint", label: "SharePoint", title: "Search the SharePoint documents." },
  { scope: "mail", label: "Mail", title: "Also search your own Outlook mail. Only you can see these results." },
  { scope: "teams", label: "Teams", title: "Also search your own Teams chats. Only you can see these results." },
]

interface ScopePickerProps {
  scopes: SearchScope[]
  onToggle: (scope: SearchScope) => void
}

/** Classic mode: which sources a request searches. Mail and Teams use the user's own token. */
export function ScopePicker({ scopes, onToggle }: ScopePickerProps) {
  return (
    <div role="group" aria-label="Search scope" className="flex items-center gap-1">
      {OPTIONS.map(({ scope, label, title }) => {
        const checked = scopes.includes(scope)
        return (
          <button
            key={scope}
            type="button"
            role="checkbox"
            aria-checked={checked}
            title={title}
            onClick={() => onToggle(scope)}
            className={cn(
              "flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs transition-colors",
              checked
                ? "border-orange/35 bg-orange-tint text-fg1"
                : "border-transparent text-fg3 hover:bg-elevated hover:text-foreground",
            )}
          >
            <Check className={cn("size-3.5 shrink-0", !checked && "opacity-0")} />
            {label}
          </button>
        )
      })}
    </div>
  )
}
